import { render, staticRenderFns } from "./LinkRoute.vue?vue&type=template&id=c8467cca&"
import script from "./LinkRoute.vue?vue&type=script&lang=js&"
export * from "./LinkRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports